import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=286e50f6"
import script from "./EventDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EventDetail.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports